import { asArray } from "ol/color";
import Layer from 'ol/layer/Layer.js';
import VectorLayer from "ol/layer/Vector";
import WebGLVectorLayerRenderer from 'ol/renderer/webgl/VectorLayer.js'
import {packColor, parseLiteralStyle} from 'ol/webgl/styleparser.js';

const result:any = parseLiteralStyle({
  'fill-color': ['get', 'fillColor'],
  'circle-fill-color': ['get', 'fillColor'],
  'stroke-color': ['get', 'strokeColor'],
  'stroke-width': ['get', 'strokeWidth'],
  'circle-radius': 4
});


export default class WebGLLayer extends VectorLayer {
    public mapservice?:any;

    createRenderer():any {
      let self:any=this;
      return new WebGLVectorLayerRenderer(self, {
        variables:{},
        style: {
          builder: result.builder,
          attributes: {
            fillColor: {
              size: 2,
              callback: (feature) => {
                let s=self.getStyle()(feature, self.mapservice.view.getResolution());
                if(s){
                  const style = s;
                  const color = asArray(style?.getFill()?.getColor() || '#eee');
                  return packColor(color);
                }
                else{
                  console.log("error for :"+feature)
                  return packColor('#eee');
                }
                
              },
            },
            strokeColor: {
              size: 2,
              callback: (feature) => {
                let s=self.getStyle()(feature, self.mapservice.view.getResolution());
                if(s){
                  const style = s;
                  const color = asArray(style?.getStroke()?.getColor() || '#eee');
                  return packColor(color);
                }
                else{
                  console.log("error for :"+feature)
                  return packColor('#eee');
                }
              },
            },
            strokeWidth: {
              size: 1,
              callback: (feature) => {
                let s=self.getStyle()(feature, self.mapservice.view.getResolution());
                if(s){
                  const style = s;
                  return style?.getStroke()?.getWidth() || 0;
                }
                else{
                  console.log("error for :"+feature)
                  return 0;
                }
              },
            },
          },
        },
      });
    }
  }
